import { CodedProperty, deduplicateByProperty, getSortedCollection, NamedProperty } from "sprint-common-web";

import { SingleMovie, SingleMovieVersion } from "../context/SingleMovie";
import { VersionDetails } from "./useMovieAssetsListFilters";

export const useSingleMovieDetails = () => {
    const getVersionDetails = (movie?: SingleMovie): VersionDetails => {
        const versionTypes = getDeduplicatedVersionTypes(movie?.versions);
        const distributors = getDeduplicatedDistributors(movie?.versions);
        const airlines = getDeduplicatedAirlines(movie?.versions);

        return { versionTypes, distributors, airlines };
    };

    return {
        getVersionDetails
    };
};

const getDeduplicatedVersionTypes = (versions?: SingleMovieVersion[]) => {
    const versionTypes = versions?.map((version) => version.type) ?? [];
    return deduplicateByProperty<NamedProperty>(versionTypes, "id");
};

const getDeduplicatedDistributors = (versions?: SingleMovieVersion[]) => {
    const distributors = versions?.map((version) => version.distributor) ?? [];
    return deduplicateByProperty<NamedProperty>(distributors, "id");
};

const getDeduplicatedAirlines = (versions?: SingleMovieVersion[]): NamedProperty[] => {
    if (!versions) return [];

    const brandings = versions
        .map((version: SingleMovieVersion) => version.brandings ?? [])
        .reduce((a: CodedProperty[], b: CodedProperty[]) => a.concat(b), []);

    const deduplicatedBrandings = deduplicateByProperty<NamedProperty>(brandings, "id");

    return getSortedCollection(deduplicatedBrandings, "name", "asc");
};
